export enum ModuleHooksEnum {
  AfterCreateChannelModule = 'afterCreateChannelModule',
  AfterUpdateChannelModule = 'afterUpdateChannelModule',
  BeforeCreateChannelModule = 'beforeCreateChannelModule',
  BeforeUpdateChannelModule = 'beforeUpdateChannelModule',
  BeforeDeleteChannelModule = 'beforeDeleteChannelModule',
  AfterDeleteChannelModule = 'afterDeleteChannelModule',
}

export interface ModuleHooksInterface {
  [key: string]: {
    channelIntegration: any;
    hook: Function;
  }[];
}
